<template>
	<div>
		<div class="mt-4 container-fluid">
			<div class="mt-4 ml-2 mb-4 d-flex justify-content-between">
				<h1 class="h3 mb-0 text-gray-800">
					Destino
				</h1>
				<div>
					<button
						class="btn btn-primary"
						@click="update">
						<i class="fas fa-edit"></i>
					</button>
					<button
						class="btn btn-danger"
						@click="confirmDestroy()">
						<i class="fas fa-trash"></i>
					</button>
					<button
				        @click="$router.go(-1)"
				        class="btn btn-secondary">
			           	Voltar
			        </button>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<!-- Informações -->
					<entrega-destino-info
                        :dados="dados">
                    </entrega-destino-info>
				</div>
			</div>
		</div>
		<!-- Update Item -->
		<entrega-destino-update
			@reload="getDados">
		</entrega-destino-update>
		<!-- Confirmação para excluir -->
        <bsh-confirm
        	modal_id="confirm_destroy_entrega_destino"
        	:dado_id="$route.params.id"
        	title="Deseja realmente remover este destino?"
        	btn="Excluir"
        	btnStyle="btn-danger"
        	method="delete"
        	:rota="$url+'/api/adm/entrega-destinos/destroy/'"
        	@reload="back()">
        </bsh-confirm>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				dados: [],
			}
		},
		created(){
			this.getDados();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/entrega-destinos/show/'+this.$route.params.id)
	            .then(response => {
	            	this.dados = response.data
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
			update(){
				$('#update_entrega_destino').modal('show');
			},
			confirmDestroy(){
				$('#confirm_destroy_entrega_destino').modal('show');
			},
			back(){
				this.$router.go(-1)
			}
		}
	}
</script>
